import type { CotizaTodasResponse } from '@/types/quote.types';
import type { useQuoteGeneration } from '@/composables/useQuoteGeneration';

export type ResultsCompany = 'QUALITAS' | 'ANA' | 'CHUBB';

export type ResultsLogoType = 'qualitas' | 'ana' | 'chubb';

export interface Documento {
  Guid_Documento: string;
  Nombre?: string;
  Tipo?: string;
  Id_Solicitud?: number;
}

export interface EmissionSuccessData {
  policyData: {
    policyNumber?: string;
    idPoliza?: number;
    idSolicitud?: number;
    planType?: string;
    primaTotal?: number;
  };
  documentos: Documento[];
}

export interface ResultsViewProps {
  quotesResponse: CotizaTodasResponse | null;
  isLoading?: boolean;
  allowEmission?: boolean;
  quoteGeneration?: ReturnType<typeof useQuoteGeneration>;
}

export interface CompanyCardItem {
  company: ResultsCompany;
  name: string;
  logoSrc: string;
  logoType: ResultsLogoType;
  price: number;
  firstPayment: number;
  subsequentPayment: number;
  subsequentCount: number;
  isBestPrice: boolean;
  emittable: boolean;
}

/** Emission / PDF / share only for Qualitas and ANA. */
export type EmittableCompany = 'QUALITAS' | 'ANA';

export function isEmittableCompany(company: ResultsCompany): company is EmittableCompany {
  return company === 'QUALITAS' || company === 'ANA';
}
